export class NodeConfig {}

export class HpcConfig {
  hpcConfigId?: number = 0;
  cloudProvider?: string = '';
  instanceCode: string = '';
  cpuCores: number = 0;
  hpcUnits: number = 0;
  cpuType?: string = '';
  ramSize?: string = '';
  hddSize?: string = '';
  description?: string = '';
  maxHpcNodes: number = 0;
  pricePerHour: number = 0;
  isRdmaSupported: boolean = false;
  numOfSockets: number = 0;
  coresPerSocket: number = 0;
  threadsPerCore: number = 0;
  hddType: string = '';
  noOfGPU: number = 0;
  gpuMemorySize: number = 0;
  gpuModel: string = '';
  cpuModel: string = '';
}
